<template>
  <div class="content">
    <div class="loginView">
      <div class="outLine">
        <div class="name">天悦易课-金品校本资源网</div>
        <div class="account">
          <img class="bgc_a" src="../assets/images/login/login_a.png" alt="" />
          <div class="newView">
            <div class="newViewBlock">
              <div class="title">忘记密码</div>
              <div class="phoneView">
                <img class="phone" src="../assets/images/login/phone.png" alt="" />
                <el-input placeholder="请输入手机号" v-model="phone" autocomplete="new-password">
                </el-input>
              </div>
              <div class="phoneView">
                <img class="phone" src="../assets/images/login/code.png" alt="" />
                <el-input placeholder="请输入验证码" v-model="code" autocomplete="new-password">
                </el-input>
                <div class="pasCode">发送验证码</div>
              </div>
              <div class="phoneView">
                <img class="phone" src="../assets/images/login/password.png" alt="" />
                <el-input placeholder="请输入密码" type="password" v-model="password" autocomplete="new-password">
                </el-input>
              </div>
              <div class="forPassword">
                <span class="goFor" @click="goForget">去登录</span>
              </div>
              <div style="margin-top: 46px;">
                <el-checkbox v-model="checked">同意<span class="t1">《用户协议》</span>和<span
                    class="t1">《隐私政策》</span></el-checkbox>
              </div>
              <div class="loginBlock" style="cursor: pointer;" @click="getReset">确定修改</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getResetpwdApi
} from "@/api/index";
export default {
  mixins: [],
  components: {
  },
  data() {
    return {
      checked: true,
      phone: '',    //手机号
      code: '',     //验证码
      password: ''  //密码
    };
  },
  created() {
    //取
    // this.phone = JSON.parse(localStorage.getItem("account")) || '';
    // this.password = JSON.parse(localStorage.getItem("password")) || '';
    this.phone = '';
    this.password = '';
    this.code = "";
  },
  mounted() {

  },
  methods: {
    async getReset() {
      if (!this.checked) {
        this.$message({
          message: '请勾选用户协议',
          type: 'warning'
        });
        return
      }

      await getResetpwdApi({

        type: 'mobile',
        newpassword: this.password,
        mobile: this.phone,   //13001903775
        captcha: this.code    //1036

      }).then((res) => {
        if (res.code == 1) {
          this.$message({
            message: res.msg,
            type: 'success'
          });
          setTimeout(() => {
            this.$router.push({
              path: "/",
            })
          }, 1000);
        }

        if (res.code == 0) {
          this.$message({
            message: res.msg,
            type: 'error'
          });
        }
      }).catch((err) => {
        console.log(err);
      })
    },
    // 去登录
    goForget() {
      this.$router.push({
        path: "/"
      })
    }
  },
};
</script>

<style lang="scss" scoped>
.content {
  width: 100%;
  height: 100%;

  .loginView {
    background-image: url("../assets/images/login/login_bgc.png");
    background-size: 100% 100%;
    background-position: center center;
    width: 1200px;
    height: 688px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    justify-content: center;

    .outLine {
      margin-top: -20px;
      width: 1169px;
      height: 635px;
      // opacity: 0.2;
      background: rgba(228, 80, 75, 0.2);
      border-radius: 40px;

      .name {
        margin: 70px 0 0 104px;
        font-size: 40px;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: 400;
        color: #ffffff;
      }

      .account {
        display: flex;
        justify-content: space-around;
        align-items: center;

        .bgc_a {
          margin-top: 40px;
          width: 485px;
          height: 434px;
        }

        .newView {
          margin-top: -20px;
          width: 436px;
          height: 537px;
          background: #ffffff;
          border-radius: 21px;

          .newViewBlock {
            margin: 39px 28px;

            .title {
              font-size: 26px;
              font-family: PingFang SC, PingFang SC-Bold;
              font-weight: 700;
              color: #333333;
              margin-bottom: 45px;
            }

            .phoneView {
              margin-top: 16px;
              width: 373px;
              height: 55px;
              border: 1px solid #d9242a;
              border-radius: 4px;
              display: flex;
              justify-content: center;
              align-items: center;
              position: relative;

              .phone {
                width: 18px;
                height: 24px;
              }

              .pasCode {
                color: #D9242A;
                top: 15px;
                right: 14px;
                position: absolute;
              }
            }

            .forPassword {
              margin-top: 10px;
              width: 100%;
              text-align: right;

              .goFor {
                cursor: pointer;
                font-size: 15px;
                font-family: PingFang SC, PingFang SC-Regular;
                font-weight: 400;
                color: #999999;
              }
            }

            .loginBlock {
              margin-top: 28px;
              display: flex;
              justify-content: center;
              align-items: center;
              width: 373px;
              height: 54px;
              background: #e93531;
              border-radius: 8px;
              font-size: 19px;
              font-family: PingFang SC, PingFang SC-Regular;
              font-weight: 400;
              color: #ffffff;
            }
          }

        }
      }
    }
  }
}

::v-deep .el-input {
  width: 85% !important;
}

::v-deep .el-input__inner {
  border: none !important;
}

::v-deep .el-checkbox__inner {
  background-color: #D9242A !important;
  color: #D9242A !important;
}

::v-deep .el-checkbox__label {
  font-size: 15px;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  color: #999999 !important;
}

.t1 {
  color: #D9242A;
}
</style>
